<template>
  <CustomModal ref="modal" title="Échec du téléversement">
    <div class="invoice-upload-error-modal">
      <p>Échec du téléversement de « {{ documentLabel }} » :</p>
      <div class="error-box">{{ errorMessage }}</div>

      <p>Corrigez d'abord les informations manquantes ou incorrectes, dans la fiche du client ou les informations administratives de votre entreprise, puis réessayez d'envoyer le document.</p>
      <p class="warning">Si l'envoi échoue encore, utilisez « Recharger le document » pour régénérer les PDF avec les informations corrigées. Les montants ne seront pas modifiés. Cette opération concerne tous les documents non transmis du contrat (factures, acomptes et avoirs).</p>

      <div class="buttons">
        <CustomButton @click="closeModal" :is-secondary="true" :params="buttons.close" />
        <CustomButton @click="reload" :params="buttons.reload" />
      </div>
    </div>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";

export default {
  name: 'InvoiceUploadErrorModal',
  components: {CustomModal, CustomButton},
  props: {
    callback: {type: Function, default: undefined},
  },
  data: function () {
    return {
      businessId: undefined,
      documentLabel: '',
      errorMessage: '',
      isLoading: false,
      buttons: {
        close: {text: "Fermer"},
        reload: {text: "Recharger avec les éléments mis à jour"},
      },
    };
  },
  methods: {
    openModal(business, documentLabel, errorMessage) {
      this.businessId = business.id;
      this.documentLabel = documentLabel;
      this.errorMessage = errorMessage;
      this.$refs.modal.openModal();
    },
    closeModal() {
      this.$refs.modal?.closeModal();
    },
    async reload() {
      if (this.isLoading) return;
      this.isLoading = true;

      const resp = await BusinessController.reloadClientInformations(this.businessId);

      this.isLoading = false;

      if (resp && !resp.errors) {
        (new NotificationService).addNotification("success", "Informations du client rechargées, vous pouvez relancer le téléversement");
        this.closeModal();
        if (this.callback) await this.callback();
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.invoice-upload-error-modal
  display flex
  flex-direction column
  gap 10px

  .error-box
    max-height 150px
    overflow-y auto
    padding 10px
    border 1px solid #dc0000
    border-radius 6px
    color #dc0000
    white-space pre-wrap
    word-break break-word

  .warning
    color #d58900
    font-weight bold

  .buttons
    display flex
    justify-content flex-end
    gap 10px
</style>